import { atom } from 'recoil'


export const createdConstructionNameState = atom<string>({
    key: 'createdConstructionName',
    default: '',
})